// src/components/Auth/MockAuth0Provider.js
// Mock Auth0Provider for E2E testing - bypasses Auth0 authentication
import React, { createContext, useContext } from 'react';

const mockUser = {
  sub: 'auth0|mock-user-id',
  email: 'e2e-test@example.com',
  email_verified: true,
  name: 'E2E Test User',
  nickname: 'e2e-test',
  picture: 'https://via.placeholder.com/150',
  updated_at: new Date().toISOString(),
};

const mockAuthContext = {
  isAuthenticated: true,
  isLoading: false,
  user: mockUser,
  loginWithRedirect: () => Promise.resolve(),
  loginWithPopup: () => Promise.resolve(),
  logout: () => {
    // Clear mock auth state
    localStorage.removeItem('e2e_mock_auth_mode');
    window.location.href = '/';
  },
  getAccessTokenSilently: () => Promise.resolve('mock-access-token-for-e2e-tests'),
  getAccessTokenWithPopup: () => Promise.resolve('mock-access-token-for-e2e-tests'),
  getIdTokenClaims: () => Promise.resolve({
    __raw: 'mock-id-token',
    ...mockUser,
    iss: 'https://localhost/',
    aud: 'local-client-id',
    iat: Math.floor(Date.now() / 1000),
    exp: Math.floor(Date.now() / 1000) + 86400,
  }),
  error: undefined,
};

// Create a mock context that matches Auth0's context
const MockAuth0Context = createContext(mockAuthContext);

// Hook that matches useAuth0
export const useMockAuth0 = () => {
  return useContext(MockAuth0Context);
};

// Provider that matches Auth0Provider interface
export const MockAuth0Provider = ({ children }) => {
  return (
    <MockAuth0Context.Provider value={mockAuthContext}>
      {children}
    </MockAuth0Context.Provider>
  );
};

// Check if E2E test mode is enabled
export const isE2ETestMode = () => {
  return (
    process.env.REACT_APP_E2E_TEST_MODE === 'true' ||
    (typeof window !== 'undefined' && localStorage.getItem('e2e_mock_auth_mode') === 'true')
  );
};

export default MockAuth0Provider;
